import Component from '@glimmer/component';
import type { Signature as BaseCancerFormSignature } from '../base-cancer-form';
import BaseCancerForm from '../base-cancer-form';

interface Signature {
  Args: Pick<BaseCancerFormSignature['Args'], 'form' | 'patient'>;
}

export default class MedicalHistoryFormHematoCancerDiagnosticFieldsComponent extends Component<Signature> {
  BaseCancerForm = BaseCancerForm;

  <template>
    <this.BaseCancerForm @form={{@form}} @patient={{@patient}}>
      <:content>
        <@form.BasicRadioGroup
          @title='Type du cancer'
          @propertyName='hemato-cancer-type'
          as |Group|
        >
          <div class='fields inline'>
            <div class='field'>
              <Group.Radio @label='Leucémie' @value='leukemia' />
            </div>
            <div class='field'>
              <Group.Radio @label='Myélome' @value='myeloma' />
            </div>
            <div class='field'>
              <Group.Radio @label='Lymphome' @value='lymphoma' />
            </div>
          </div>
        </@form.BasicRadioGroup>
      </:content>
    </this.BaseCancerForm>
  </template>
}
